import axios from 'axios'
import i18n, { DEFAULT_LANGUAGE } from '../i18n'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL + '/api',
  withCredentials: true,
})

function getAcceptLanguage(): string {
  return i18n.language?.split('-')[0] || DEFAULT_LANGUAGE
}

api.defaults.headers.common['Accept-Language'] = getAcceptLanguage()

api.interceptors.request.use(config => {
  config.headers['Accept-Language'] = getAcceptLanguage()
  return config
})

api.interceptors.response.use(
  r => r,
  async err => {
    const originalRequest = err.config
  const isAuthRoute = originalRequest?.url?.includes('/auth/')

    if (err?.response?.status === 401 && !isAuthRoute) {
      const onLoginRoute =
        typeof window !== 'undefined' && window.location?.pathname?.startsWith('/login')

      if (!onLoginRoute) {
        window.location.href = '/login'
      }
    }

    return Promise.reject(err)
  }
)

/** @deprecated Cookie sessions are used; kept for compatibility with existing imports. */
export function setAuth(_token?: string) {
  // no-op: Better Auth manages session cookies
}
